import { Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import {firstValueFrom, from} from 'rxjs';

import {
  BaseTableComponent,
  basicDeleteTemplateOptions,
  basicEditTemplateOptions,
  TableContextMenu,
  TableField,
  UiTableComponent,
} from '@ui/ui.module';

import { SwalService } from '@atmi/core';

import { Role } from '@sim/role/models/role';
import { RoleApiService } from '@sim/role/services/role-api.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-roles',
  styleUrls: ['./roles.component.scss'],
  templateUrl: './roles.component.html',
})
export class RolesComponent extends BaseTableComponent<Role> implements UiTableComponent<Role> {

  readonly fields: TableField<Role>[] = [
    {
      header: '',
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'chekbox',
      selectable: true,
    },
    {
      header: this.translate.instant('Nome'),
      key: 'name',
    },
    {
      context: (item) => item.capabilities.length,
      header: this.translate.instant('Capabilities'),
      key: '',
    },
    {
      header: this.translate.instant('Data creazione'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'createdAt',
      template: 'date-time',
    },
    {
      align: 'right',
      header: '',
      key: 'context',
      showBreakpoints: [Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium],
      template: 'context',
    },
  ];

  readonly pager$ = (() => this.roleApi.index());

  readonly contextMenus: Array<TableContextMenu<Role>> = [
    {
      action: (item) => this.router.navigate(['/roles/manager', item.id]),
      label: this.translate.instant('Modifica'),
    },
    {
      action: (item) => item.id ? this.deleteHandler(item.id) : () => undefined,
      label: this.translate.instant('Elimina'),
    },
  ];

  constructor(
    protected readonly translate: TranslateService,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly swalService: SwalService,
    private readonly roleApi: RoleApiService,
  ) {
    super(translate, router, route, swalService);

    this.fields.push(basicEditTemplateOptions);
    this.fields.push(basicDeleteTemplateOptions);
  }

  deleteConcreteHandler(id: string) {
    return this.roleApi.remove(id);
  }

  deleteSelectedConcreteHandler(ids: string[]) {
    const deleteApis = ids.map((id) => firstValueFrom(this.roleApi.remove(id)));

    return from(Promise.all(deleteApis));
  }
}
